(() => {
  'use strict';
  if (customElements.get('smooche-installments')) return;
  customElements.define('smooche-installments', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('[data-section-type="product-template"]') || this.closest('.shopify-section');
      if (!this.root) return;
      this.variantPrice = Number(this.dataset.price) / 100;
      this.format = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
      this.variantChanged = event => {
        if (event.detail?.variant) this.variantPrice = event.detail.variant.price / 100;
        this.sync();
      };
      this.root.addEventListener('theme:variant:change', this.variantChanged);
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
      this.sync();
    }
    sync() {
      const bundlePrice = this.root.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price');
      let price = this.variantPrice;
      if (bundlePrice) {
        // Kaching renders localized money. The last separator is decimal only
        // when followed by one or two digits; other separators are grouping.
        const digits = bundlePrice.textContent.replace(/[^0-9.,]/g, '');
        const decimal = digits.match(/[.,](\d{1,2})$/);
        price = decimal ? Number(digits.slice(0, decimal.index).replace(/[.,]/g, '') + '.' + decimal[1]) : Number(digits.replace(/[.,]/g, ''));
        if (!digits || !Number.isFinite(price)) { this.style.display = 'none'; return; }
      }
      const output = this.querySelector('strong');
      if (!output || !Number.isFinite(price)) return;
      this.style.display = 'block';
      const text = this.format.format(price / 4);
      if (output.textContent !== text) output.textContent = text;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.root?.removeEventListener('theme:variant:change', this.variantChanged);
    }
  });
})();
